import { EnvironmentProviders, inject, makeEnvironmentProviders, provideEnvironmentInitializer } from '@angular/core'

import { RouteScrollHandler } from './route-scroll-hanlder.service'

/** provides AND sets up the {@link RouteScrollHandler} */
export function provideRouteScrollHandler(): EnvironmentProviders {
  return makeEnvironmentProviders([
    RouteScrollHandler,
    provideEnvironmentInitializer(() => inject(RouteScrollHandler).setup()),
  ])
}
